@if (!isMobile) {
    <form class="filter-bar-content" [formGroup]="ElForm">
      <div class="full-width add-space-after" rtlDiv>
        @if(page == 'inventory') {
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(sitesList)" #sitesSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="site" name="site" multiple placeholder="{{sites_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{sites_Title}} 
                    @if(getSelectedSites.length > 1) {
                      <span class="selected-count">+{{getSelectedSites.length}}</span>
                    }
                    @if(getSelectedSites.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedSites[0].site}}</span>                  
                        <img (click)="clearSiteFilter();applySiteFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchSites($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (site of displaySitesList; track site) {
                    <mat-option class="option-item" [value]="site.site" rtlDiv (click)="siteOptionClick(site)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{site.site}}</span>
                        <span rtlDiv>({{site.num_of_bins_in_site}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearSiteFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applySiteFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
    
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(typesList)" #typesSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="type" name="type" multiple placeholder="{{types_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{types_Title}} 
                    @if(getSelectedTypes.length > 1) {
                      <span class="selected-count">+{{getSelectedTypes.length}}</span>
                    }
                    @if(getSelectedTypes.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedTypes[0].type}}</span>                  
                        <img (click)="clearTypeFilter();applyTypeFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchTypes($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (type of displayTypesList; track type) {
                    <mat-option class="option-item" [value]="type.type" rtlDiv (click)="typeOptionClick(type)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{type.type}}</span>
                        <span rtlDiv>({{type.num_of_bins_in_type}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearTypeFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyTypeFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
    
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(neighborhoodsList)" #neighborhoodSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="neighborhood" name="neighborhood" multiple placeholder="{{neighborhood_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{neighborhood_Title}} 
                    @if(getSelectedNeighborhoods.length > 1) {
                      <span class="selected-count">+{{getSelectedNeighborhoods.length}}</span>
                    }
                    @if(getSelectedNeighborhoods.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedNeighborhoods[0].neighborhood}}</span>                  
                        <img (click)="clearNeighborhoodFilter();applyNeighborhoodFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchNeighborhoods($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (neighborhood of displayNeighborhoodsList; track neighborhood) {
                    <mat-option class="option-item" [value]="neighborhood.neighborhood" rtlDiv (click)="neighborhoodOptionClick(neighborhood)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{neighborhood.neighborhood}}</span>
                        <span rtlDiv>({{neighborhood.num_of_bins_in_nbrh}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearNeighborhoodFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyNeighborhoodFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
    
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(collectionModeList)" #collectionModeSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="collectionMode" name="collectionMode" multiple placeholder="{{collectionMode_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{collectionMode_Title}} 
                    @if(getSelectedCollectionModes.length > 1) {
                      <span class="selected-count">+{{getSelectedCollectionModes.length}}</span>
                    }
                    @if(getSelectedCollectionModes.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedCollectionModes[0].name}}</span>                  
                        <img (click)="clearCollectionModeFilter();applyCollectionModeFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchCollectionModes($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (collectionMode of displayCollectionModeList; track collectionMode) {
                    <mat-option class="option-item" [value]="collectionMode.id" rtlDiv (click)="collectionModeOptionClick(collectionMode)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{collectionMode.name}}</span>
                        <span rtlDiv>({{collectionMode.num_of_bins_in_collection_mode}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearCollectionModeFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyCollectionModeFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
        }@else if(page == 'ticketManagement' || page == 'technicianTicketManagement') {
          @if(page == 'technicianTicketManagement') {
            <div class="form-field">
              <mat-form-field class="form-field-container" rtlDiv>
                <mat-select (openedChange)="sortOptions(ticketTypeList)" #ticketTypeSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="ticketType" name="ticketType" multiple placeholder="{{ticketType_Title}}">
                  <mat-select-trigger rtlDiv>
                    <div class="select-trigger-container">
                      {{ticketType_Title}} 
                      @if(getSelectedTicketTypes.length > 1) {
                        <span class="selected-count">+{{getSelectedTicketTypes.length}}</span>
                      }
                      @if(getSelectedTicketTypes.length == 1) {
                        <span class="selected-count">
                          <span>{{currentLang == 'iw' ? getSelectedTicketTypes[0].ticket_type_hebrew : getSelectedTicketTypes[0].ticket_type}}</span>                  
                          <img (click)="clearTicketTypeFilter();applyTicketTypeFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                        </span>
                      }
                    </div>
                  </mat-select-trigger>
                  <div class='search-input-container' rtlDiv>
                    <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                    <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchTicketTypes($event.target)" rtlDiv>
                  </div> 
                  <div class="options-container">
                    @for (ticketType of displayTicketTypeList; track ticketType) {
                      <mat-option class="option-item" [value]="ticketType.ticket_type" rtlDiv (click)="ticketTypeOptionClick(ticketType)">
                        <div class="dropdown-option">
                          <span rtlDiv>{{currentLang == 'iw' ? ticketType.ticket_type_hebrew : ticketType.ticket_type}}</span>
                          <span rtlDiv>({{ticketType.num_of_tickets_in_ticket_type}})</span>
                        </div>
                      </mat-option>
                    }
                  </div>
                  <div class="btns-container" rtlDiv>
                    <div class="clear-btn" (click)="clearTicketTypeFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                    <div class="apply-btn" (click)="applyTicketTypeFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          }
  
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(eventCauseList)" #eventCauseSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="eventCause" name="eventCause" multiple placeholder="{{eventCause_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{eventCause_Title}} 
                    @if(getSelectedEventCauses.length > 1) {
                      <span class="selected-count">+{{getSelectedEventCauses.length}}</span>
                    }
                    @if(getSelectedEventCauses.length == 1) {
                      <span class="selected-count">
                        <span>{{currentLang == 'iw' ? getSelectedEventCauses[0].eventCauseHe : getSelectedEventCauses[0].eventCauseEn}}</span>                  
                        <img (click)="clearEventCauseFilter();applyEventCauseFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchEventCauses($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (eventCause of displayEventCauseList; track eventCause) {
                    <mat-option class="option-item" [value]="eventCause.eventCauseEn" rtlDiv (click)="eventCauseOptionClick(eventCause)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{currentLang == 'iw' ? eventCause.eventCauseHe : eventCause.eventCauseEn}}</span>
                        <span rtlDiv>({{eventCause.num_of_bins_in_event_cause}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearEventCauseFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyEventCauseFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(statusList)" #statusSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="status" name="status" multiple placeholder="{{status_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{status_Title}} 
                    @if(getSelectedStatuses.length > 1) {
                      <span class="selected-count">+{{getSelectedStatuses.length}}</span>
                    }
                    @if(getSelectedStatuses.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedStatuses[0].status_txt}}</span>                  
                        <img (click)="clearStatusFilter();applyStatusFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchStatuses($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (status of displayStatusList; track status) {
                    <mat-option class="option-item" [value]="status.status" rtlDiv (click)="statusOptionClick(status)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{status.status_txt}}</span>
                        <span rtlDiv>({{status.num_of_tickets_in_status}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearStatusFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyStatusFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
          
        }@else if(page == 'workplanTruckList') {
          <div class="form-field">
            <mat-form-field class="form-field-container" rtlDiv>
              <mat-select (openedChange)="sortOptions(exceptionsList)" #exceptionsSelect panelClass="filter-bar-select" class="full-height" rtlDiv formControlName="exception" name="exception" multiple placeholder="{{exceptions_Title}}">
                <mat-select-trigger rtlDiv>
                  <div class="select-trigger-container">
                    {{exceptions_Title}} 
                    @if(getSelectedExceptions.length > 1) {
                      <span class="selected-count">+{{getSelectedExceptions.length}}</span>
                    }
                    @if(getSelectedExceptions.length == 1) {
                      <span class="selected-count">
                        <span>{{getSelectedExceptions[0].name}}</span>                  
                        <img (click)="clearExceptionFilter();applyExceptionFilter();$event.stopPropagation()" class="close-img" src="assets/images/dashboard/closeX.svg" rtlDiv>
                      </span>
                    }
                  </div>
                </mat-select-trigger>
                <div class='search-input-container' rtlDiv>
                  <img rtlDiv class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />      
                  <input class="filter-input" placeholder="{{'OTHER.SEARCH' | translate}}" type="text" (keydown)="$event.stopPropagation()" (input)="searchExceptions($event.target)" rtlDiv>
                </div> 
                <div class="options-container">
                  @for (exception of displayExceptionsList; track exception.key) {
                    <mat-option class="option-item" [value]="exception.key" rtlDiv (click)="exceptionOptionClick(exception)">
                      <div class="dropdown-option">
                        <span rtlDiv>{{exception.name}}</span>
                        <span rtlDiv>({{exception.num_of_bins_in_exception}})</span>
                      </div>
                    </mat-option>
                  }
                </div>
                <div class="btns-container" rtlDiv>
                  <div class="clear-btn" (click)="clearExceptionFilter()">{{ 'TICKET_MANAGEMENT.CLEAR' | translate }}</div>
                  <div class="apply-btn" (click)="applyExceptionFilter()">{{ 'TITLES.APPLY' | translate }}</div>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
        }
  
        <span class="clear-all-btn" (click)="clearAllFilters()">{{ 'LIVE_INFO.CLEAR_ALL'| translate }}</span>
      </div>
    </form>
  }
  
  @if (isMobile) {
    <div class="mobile-filter-bar" rtlDiv>
      <button class="mobile-filter-trigger" (click)="openFilterSheet()" rtlDiv>
        <svg class="filter-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2 4h12M4 8h8M6 12h4" stroke="#485760" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>{{ 'OTHER.FILTERS' | translate }}</span>
        @if(totalActiveFilters > 0) {
          <span class="mobile-filter-badge">{{ totalActiveFilters }}</span>
        }
      </button>
      @if(totalActiveFilters > 0) {
        <span class="mobile-clear-all" (click)="clearAllFilters()">{{ 'LIVE_INFO.CLEAR_ALL' | translate }}</span>
      }
    </div>
  }
  